import { Pipe, PipeTransform } from '@angular/core';

export const removeDefault = (name: string) => {
  return name ? name.replace(' - DEFAULT', '').replace('DEFAULT', '').trim() : '';
};

@Pipe({
  name: 'removeDefault',
  standalone: true,
})
export class RemoveDefaultPipe implements PipeTransform {
  transform(name: string): string {
    return removeDefault(name);
  }
}
